var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBombExplode = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.875 6.364 1.446 8.95L29 4.181l-6.175 12.533 8.716-3.26-7.27 5.688L38 18.363l-13.73 3.585 7.27 5.688-8.715-3.26 2.8 5.988-5.304-4.586L18.875 38l-1.446-12.222-3.95 6.767 1.446-8.17L2 30.365l11.48-8.416L2 18.364l11.48.78L2 9.635l12.925 7.08L12.125 2l5.304 13.313 1.446-8.95Z"
})));
export default SvgBombExplode;